'use client'

import classNames from 'classnames'
import React, { useEffect } from 'react'

import { ReactComponent as CloseIcon } from '~/assets/icons/close.svg'
import useOutsideClick from '~/hooks/use-click-outside'

import HeaderSvg from '../popup/header-svg'

interface Properties {
  isActive: boolean
  onClose: () => void
}

const Modal: React.FC<React.PropsWithChildren<Properties>> = ({
  isActive,
  onClose,
  children,
}) => {
  const reference = useOutsideClick<HTMLDivElement>(() => {
    if (isActive) {
      onClose()
    }
  })

  useEffect(() => {
    document.body.style.overflow = isActive ? 'hidden' : 'auto'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [isActive])

  return (
    <div
      className={classNames(
        'fixed top-0 left-0 w-full h-full z-[9999] overflow-hidden',
        {
          'pointer-events-auto overflow-y-auto': isActive,
          'pointer-events-none overflow-y-hidden': !isActive,
        }
      )}
      aria-hidden={!isActive}
    >
      <div className="relative flex justify-center items-center w-full h-full md:h-auto md:min-h-full lg:py-8">
        <div
          className={classNames(
            'absolute top-0 transition-opacity !duration-500 left-0 z-0 w-full h-full bg-neutral-black/70',
            {
              'opacity-100': isActive,
              'opacity-0': !isActive,
            }
          )}
        />

        <div
          className={classNames(
            'relative z-10 transition-[opacity,transform] duration-300 ease-out w-full h-full md:h-auto sm:max-w-max max-w-[22.5rem] max-h-[39rem] bg-neutral-white',
            {
              'scale-75 opacity-0': !isActive,
            }
          )}
          ref={reference}
        >
          <HeaderSvg></HeaderSvg>
          <button
            className="absolute top-4 right-4 sm:top-6 sm:right-6 transition-colors duration-300 ease-out hover:text-red-500"
            onClick={onClose}
            aria-label="Fechar modal"
          >
            <CloseIcon className="w-10 h-10 sm:w-8 sm:h-8" />
          </button>
          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal
